export const handlePlanName = (planName: string) => {
  switch (planName) {
    case 'professional' || 'Professional':
      return 'Pro'
    default:
      return planName
  }
}
